import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { Card } from "@/components/ui/card";
import { useEffectivePermissions, useHasPermission } from "@/lib/auth/permissions";

export function StockGuard() {
  const { t } = useTranslation();
  const { isLoading } = useEffectivePermissions();
  const canRead = useHasPermission("pos.stock.read");

  if (isLoading) return null;

  if (!canRead) {
    return (
      <div className="p-6 max-w-6xl mx-auto">
        <Card className="text-sm text-ink-500 p-6">{t("rbac.noAccess")}</Card>
      </div>
    );
  }

  return <Outlet />;
}
